import qs from 'qs'
import { NextRouter } from 'next/router'
import { CheckoutStyle } from '@primer-io/checkout-web'

import { CustomData, Utms } from 'types/order'
import { MetaData } from './../types/primer'

import getCookie from './cookieHelper'
import getClientId, { getGA4SessionId } from './googleAnalyticsHelper'

export const getQueryParams = (
  router: NextRouter,
  coloring: Utms,
  orderId: number,
  chance: boolean,
  customData?: CustomData
): MetaData => {
  const originHost = window.location.origin
  const originPath = `/${router.locale}/${router.query.pipe}`

  const queryParams = {
    origin_host: originHost,
    origin_path: originPath,
    origin_id: orderId,
    successful_payment_path: `${originHost}${originPath}/20-thank-you?${qs.stringify(
      coloring
    )}`,
    failed_payment_path: `${originHost}${originPath}/19-checkout-retry?${qs.stringify(
      coloring
    )}`,
    chance: chance,
    initiated_remotely: true,
    utm_source: coloring.utm_source || '',
    utm_medium: coloring.utm_medium || '',
    utm_campaign: coloring.utm_campaign || '',
    utm_term: coloring.utm_term || '',
    utm_content: coloring.utm_content || '',
    ga_cid: getClientId(),
    fbp: getCookie('_fbp'),
    fbc: getCookie('_fbc'),
    ga_session_id: getGA4SessionId(),
    fb_ads_id: customData?.fb_ads_id || '',
  }

  return queryParams
}

export const PRIMER_CHECKOUT_STYLE: CheckoutStyle = {
  stylesheets: [
    {
      href: 'https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap',
    },
  ],
  loadingScreen: {
    color: '#2a9d8f',
  },
  formSpacings: {
    betweenInputs: '5px',
    betweenLabelAndInput: '8px',
  },
  inputLabel: {
    fontFamily: "'Source Sans Pro', sans-serif",
    fontSize: '14px',
    color: '#404040',
  },
  input: {
    base: {
      background: '#fff',
      fontFamily: "'Source Sans Pro', sans-serif",
      letterSpacing: '0.2px',
      placeholder: {
        color: 'rgba(64, 64, 64, 0.4)',
      },
      focus: {
        background: '#dff8f5',
        borderStyle: 'solid',
        borderColor: '#464646',
        borderWidth: '1px',
        color: '#464646',
      },
    },
  },
  submitButton: {
    base: {
      color: '#fff',
      background: 'linear-gradient(262deg, #54ccc2, #2a9d8f)',
      fontSize: '20px',
      fontWeight: '500',
      letterSpacing: '1.25px',
      textTransform: 'uppercase',
      hover: {
        background: 'red',
      },
    },
    loading: {
      background: '#ced5da',
    },
    disabled: {
      background: '#ced5da',
    },
  },
  paymentMethodButton: {
    marginTop: '24px',
  },
  processingIndicator: {
    color: '#2a9d8f',
  },
  separator: {
    color: '#2a9d8f',
  },
}

export const PAYMENT_HOST = process.env.NEXT_PUBLIC_PAYMENT_HOST
// Default should be 15 if not set - cause in DB 15 - its an fall-back
const PRIMER_HARDCODED_PAYMENT_ID = 15

export const getPrimerPaymentId = (): number => {
  const PRIMER_PAYMODE_ID = process.env.NEXT_PUBLIC_PRIMER_PAYMODE_ID

  if (typeof PRIMER_PAYMODE_ID === 'string') {
    return parseInt(PRIMER_PAYMODE_ID, 10)
  }

  return PRIMER_HARDCODED_PAYMENT_ID
}
